import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7d6611a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = {
  class: "inventory-table"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-row"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-cell left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text title"
}, "Inventory type")]), /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-cell right"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text title right"
}, "Quantity")])], -1));
const _hoisted_4 = {
  class: "inventory-row"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-cell left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text"
}, "Available for Fulfillment"), /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text sub"
}, "Ready to ship inventory")], -1));
const _hoisted_6 = {
  class: "inventory-cell right"
};
const _hoisted_7 = {
  class: "inventory-text quantity"
};
const _hoisted_8 = {
  class: "inventory-row"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-cell left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text"
}, "Reserved for FC Transfers"), /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text sub"
}, " Stock allocated for fulfillment centers moves ")], -1));
const _hoisted_10 = {
  class: "inventory-cell right"
};
const _hoisted_11 = {
  class: "inventory-text quantity"
};
const _hoisted_12 = {
  class: "inventory-row"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-cell left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text"
}, "Inbound Receiving"), /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text sub"
}, " Stock being processed at fulfillment centers ")], -1));
const _hoisted_14 = {
  class: "inventory-cell right"
};
const _hoisted_15 = {
  class: "inventory-text quantity"
};
const _hoisted_16 = {
  class: "inventory-row"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-cell left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text"
}, "Inbound Shipped"), /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text sub"
}, " En route to fulfillment centers, not yet received ")], -1));
const _hoisted_18 = {
  class: "inventory-cell right"
};
const _hoisted_19 = {
  class: "inventory-text quantity"
};
const _hoisted_20 = {
  class: "inventory-row"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-cell left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text"
}, "Inbound Working"), /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text sub"
}, " Being prepared for fulfillment centers shipment ")], -1));
const _hoisted_22 = {
  class: "inventory-cell right"
};
const _hoisted_23 = {
  class: "inventory-text quantity"
};
const _hoisted_24 = {
  class: "inventory-row highlight"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-cell left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text"
}, "Total Available Inventory")], -1));
const _hoisted_26 = {
  class: "inventory-cell right"
};
const _hoisted_27 = {
  class: "inventory-text quantity"
};
const _hoisted_28 = {
  class: "inventory-row muted"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-cell left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text"
}, "Reserved for Orders"), /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text sub"
}, "Set aside for pending orders")], -1));
const _hoisted_30 = {
  class: "inventory-cell right"
};
const _hoisted_31 = {
  class: "inventory-text quantity"
};
const _hoisted_32 = {
  class: "inventory-row muted"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-cell left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text"
}, "Reserved for FC Processing"), /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text sub"
}, " Undergoing fulfillment centers check-in & storage ")], -1));
const _hoisted_34 = {
  class: "inventory-cell right"
};
const _hoisted_35 = {
  class: "inventory-text quantity"
};
const _hoisted_36 = {
  class: "inventory-row muted"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-cell left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text"
}, "Under Investigation"), /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text sub"
}, "Stock review for discrepancies")], -1));
const _hoisted_38 = {
  class: "inventory-cell right"
};
const _hoisted_39 = {
  class: "inventory-text quantity"
};
const _hoisted_40 = {
  class: "inventory-row muted"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-cell left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text"
}, "Unsellable Stock"), /*#__PURE__*/_createElementVNode("div", {
  class: "inventory-text sub"
}, " Damaged or defective, not for sale ")], -1));
const _hoisted_42 = {
  class: "inventory-cell right"
};
const _hoisted_43 = {
  class: "inventory-text quantity"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock(_Fragment, null, [$props.item.available_inventory > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "inventory",
    id: `${$data.id}-inventory`
  }, null, 8, _hoisted_1)) : _createCommentVNode("", true), _createVNode(_component_app_popover, {
    target: `${$data.id}-inventory`,
    "auto-width": "",
    placement: "bottom"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString($props.item.afn_fulfillable_quantity ?? 0), 1)])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString($props.item.reserved_fc_transfers ?? 0), 1)])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString($props.item.afn_inbound_receiving_quantity ?? 0), 1)])]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString($props.item.afn_inbound_shipped_quantity ?? 0), 1)])]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString($props.item.afn_inbound_working_quantity ?? 0), 1)])]), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString($props.item.available_inventory ?? 0), 1)])]), _createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString($props.item.reserved_customerorders ?? 0), 1)])]), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString($props.item.reserved_fc_processing ?? 0), 1)])]), _createElementVNode("div", _hoisted_36, [_hoisted_37, _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString($props.item.afn_researching_quantity ?? 0), 1)])]), _createElementVNode("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, _toDisplayString($props.item.afn_unsellable_quantity ?? 0), 1)])])])]),
    _: 1
  }, 8, ["target"])], 64);
}